import { NotificationManager } from '@lst/mk-react-uikit';
import React from 'react';

import { useCopyToClipboard } from '~/hooks/useCopyToClipboard';

import styles from './CopyToClipboardButton.scss';

interface CopyToClipboardButtonProps {
  value: string;
}

const CopyToClipboardButton = ({ value }: CopyToClipboardButtonProps) => {
  const { isCopied, copy } = useCopyToClipboard();

  const onCopyHandler = async () => {
    if (isCopied) return;

    const isSuccessCopy = await copy(value);

    const message = isSuccessCopy
      ? window.notificationMessages.nicknameCopyMessage
      : window.notificationMessages.nicknameCopyErrorMessage;

    NotificationManager.sendWebNotification({
      message,
    });
  };

  return <span className={styles.copyButton} onClick={onCopyHandler} />;
};

export default CopyToClipboardButton;
